import { useProjectsStore } from '@/stores/ProjectsStore.ts';
import { useOrganizationsStore } from '@/stores/v2/OrganizationStore.ts';
import { computed } from 'vue';
import { OrganizationRights, ProjectType, Rights } from '../clients/v1/index.ts';
import { hasOrganizationRights, hasProjectRights, isSuperAdmin } from './Auth.ts';

export function useFlagsAccess() {
  const projectsStore = useProjectsStore();
  const organizationsStore = useOrganizationsStore();

  // --- User Access Logic ---
  const haveUserAccess = computed(() => {
    const isSuperAdminUser = isSuperAdmin();
    const flagEnabled = organizationsStore.usersEnabled;

    const hasProjectFullAccess =
      organizationsStore.configData &&
      hasOrganizationRights(OrganizationRights.OrganizationsProjectsFullAccess);

    const hasOrganizationUsersReadRight =
      organizationsStore.configData &&
      hasOrganizationRights(OrganizationRights.OrganizationsUsersRead);

    if (isSuperAdminUser || hasProjectFullAccess) return true;

    if (!flagEnabled) return false;

    return hasOrganizationUsersReadRight || false;
  });

  // --- Project Risks Access Logic ---
  const haveProjectRisksAccess = computed(() => {
    const project = projectsStore.project;

    if (!project) return false;

    const riskManagementEnabled = organizationsStore.riskManagementEnabled;
    const projectType = project.project_type;

    const hasProjectRisksReadRight = hasProjectRights(project.id, Rights.ProjectsRisksRead);

    if (riskManagementEnabled && projectType !== ProjectType.AiApplication) {
      return false;
    }

    return hasProjectRisksReadRight;
  });

  return {
    haveUserAccess,
    haveProjectRisksAccess,
  };
}
